<template>
  <v-app-bar
    app
    elevation="1"
    color="primary"
    dark
  >
    <!-- Logo y título -->
    <v-avatar
      size="40"
      class="mr-3"
    >
      <v-img
        src="/path-to-your-logo.png"
        alt="Twilio Logo"
      ></v-img>
    </v-avatar>

    <v-toolbar-title class="text-h6">
      Twilio Chat
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <!-- Botones de acción -->
    <v-btn
      icon
      @click="handleSearch"
    >
      <v-icon>mdi-magnify</v-icon>
    </v-btn>

    <!-- Menú de opciones -->
    <v-menu
      left
      bottom
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item
          v-for="(item, i) in menuItems"
          :key="i"
          @click="handleMenuItem(item)"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>
          <v-list-item-title v-text="item.title"></v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
export default {
  name: 'TwilioHeader',

  data: () => ({
    menuItems: [
      {
        title: 'Perfil',
        icon: 'mdi-account',
        action: 'profile'
      },
      {
        title: 'Configuración',
        icon: 'mdi-cog',
        action: 'settings'
      },
      {
        title: 'Cerrar Sesión',
        icon: 'mdi-logout',
        action: 'logout'
      },
    ]
  }),

  methods: {
    handleSearch() {
      this.$emit('search-clicked')
    },

    handleMenuItem(item) {
      this.$emit('menu-action', item.action)
    }
  }
}
</script>

<style scoped>
/* Estilos adicionales si son necesarios */
</style>
